export const POSTTAG_ERRORS = {
  ACCESS_TOKEN_EXPIRED: "Unauthorized: Token Expired",
};
